import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const TermYearCard = ( { className, id, termYear } ) => {
  return (
    <Link
      to={`/etapas/anos/${id}/edit`}
      className={`${className} card-100 card-body`}
    >
      <div className="d-flex justify-space-between">
        <p className="semi-bold brown text-underline">{termYear.term.course_offer.course}</p>
      </div>
      <div className="d-flex align-items-center mb-2">
        <div className="mr-3">
          <span className="brown">Ano:</span> {termYear.year}{' '}
        </div>
        <div className="mr-3">
          <span className="brown">Período:</span> {termYear.number}{' '}
        </div>
      </div>
    </Link>
  )
}

TermYearCard.propTypes = {
  className: PropTypes.string,
  termYear: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
}

TermYearCard.defaultProps = {
  className: '',
}

export default TermYearCard
